export default __webpack_public_path__ + "static/media/logo.774071d0.png";